import template from "./template.html";
import config from "../config";

export default function (editor) {
  const { DomComponents, BlockManager } = editor;

  DomComponents.addType("text-page-header", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("text-page-header"),
    model: {
      defaults: {
        draggable: true,
        selectable: true,
        removable: true,
        hoverable: true,
      },
    },
  });

  BlockManager.add("text-page-header", {
    ...config,
    label: "Header",
    content: template,
  });

  editor.on("rte:action:button-status", data => {
    if (["bulletedList", "numberedList"].includes(data.type)) {
      if (data.el.matches(".text-page-header h1")) data.enabled = false;
    }
  });
}
